export const generateColourRange = (startColour, endColour, steps) => {
  // Convert hex color to RGB
  function hexToRgb(hex) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    }
    // 6 digits
    else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return [r, g, b];
  }

  // Convert RGB color to hex
  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  // Linear interpolation between two values
  function interpolate(start, end, step, totalSteps) {
    return start + (end - start) * (step / totalSteps);
  }

  let startRgb = hexToRgb(startColour);
  let endRgb = hexToRgb(endColour);
  let colourRange = [];

  for (let i = 0; i < steps; i++) {
    let r = Math.round(interpolate(startRgb[0], endRgb[0], i, steps));
    let g = Math.round(interpolate(startRgb[1], endRgb[1], i, steps));
    let b = Math.round(interpolate(startRgb[2], endRgb[2], i, steps));
    colourRange.push(rgbToHex(r, g, b));
  }
  
  return colourRange;
}

//'#cb3a31', '#eb4e10', '#f39c12', '#27ae60', '#1890ff'
export const CRITICAL = '#cb3a31';
export const HIGH = '#eb4e10';
export const MEDIUM = '#f39c12';
export const LOW = '#27ae60';
export const INFO = '#1890ff';

export const APCK_GREEN = '#009D6F';
export const APCK_BLUE = '#2585A4';
